export enum TabItemPanel {
  DEFAULT = 'default',
  FILL = 'fill',
  OUTLINE = 'outline',
  FONT = 'font',
  BACKGROUND_COLOR = 'background-color',
  SEPARATOR = 'separator',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
}
